import React, { FC } from 'react';
import { IEventDetail } from '../eventInterface';
import { Typography } from '@getgo/chameleon-web/react';
import FormatStringUrl from '../../utils/formatStringUrl';

export interface IEventOverview {
  eventDetail: IEventDetail;
}

const EventOverview: FC<IEventOverview> = ({ eventDetail }) => (
  <Typography className="preserve-line-breaks" variant="body-small" color="neutral">
    <FormatStringUrl>{eventDetail.description}</FormatStringUrl>
  </Typography>
);

export default EventOverview;
